import React, { useState } from "react";
import { Badge, DefaultButton } from "../../../../../UI toolkit/Button/Button";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import {
  ActivitiesTableStyle,
  SendReceiveTableStyle,
  ActivitiesTablesHeaderStyle,
} from "./Activities.styled";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_receive_icon from "../../../../../assets/images/ic-received-coin.svg";
import ic_bought_coin from "../../../../../assets/images/ic-bought-coin.svg";
import ic_sold_coin from "../../../../../assets/images/ic-sold-coin.svg";
import ic_swapped_coin from "../../../../../assets/images/ic-swapped-coin.svg";
import { capitalizeFirstLetter } from "../../../../../utils/specialFunctions";
import ActivityModal from "./ActivityModal";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const ActivitiesTable = ({ activities }) => {
  const bgColor = (status) => {
    return status === "active" || status === "pending"
      ? "#FFEAB6"
      : status === "completed" || status === "paid"
      ? "#D1F7C4"
      : status === "stopped"
      ? "#FFDCE5"
      : "";
  };

  const color = (status) => {
    return status === "active" || status === "pending"
      ? "#606060"
      : status === "completed" || status === "paid"
      ? "#606060"
      : status === "stopped"
      ? "#531423"
      : "";
  };
  const statusKeys = {
    stopped: "broken",
    active: "ongoing",
    completed: "completed",
    pending: "pending",
    paid: "paid",
  };

  const [transaction, setTransaction] = React.useState(null);
  const [openModal, setopenModal] = useState(false);
  return (
    <div style={{ overflowX: "auto" }}>
      {/* <pre>{JSON.stringify(activities, null, 2)}</pre> */}
      {/* <pre>{JSON.stringify(transaction, null, 2)}</pre> */}
      {activities &&
        activities.map((activityGroup, idx, arr) => {
          return (
            <SendReceiveTableStyle
              className={idx % 2 === 0 ? "w-full my-10" : "w-full"}
              key={idx}
            >
              <tbody>
                <tr>
                  <td colSpan="5">
                    <div className="pt-4 pb-4 px-1.5">
                      <P fontSize="13px" color={"#7C8191"} fontWeight="500">
                        {`${timeAgo.format(
                          new Date(activityGroup.group)
                        )} — ${new Date(activityGroup.group).toDateString()}`}
                      </P>
                    </div>
                  </td>
                </tr>
                {activityGroup.data &&
                  activityGroup.data.map((activity, idx, arr) => {
                    return (
                      <tr
                        className="grid grid-cols-6 justify-center items-center"
                        style={{
                          borderBottom: "1px solid #EFF0F5",
                          width: "100%",
                        }}
                        key={activity.id}
                      >
                        <td className="pt-4 pb-4 col-start-1 col-end-2">
                          <div className="flex">
                            <div className="pr-2">
                              <img
                                src={
                                  activity.ad.action === "buy"
                                    ? ic_sent_icon
                                    : activity.ad.action === "sell"
                                    ? ic_receive_icon
                                    : activity.ad.action === "swap"
                                    ? ic_swapped_coin
                                    : ""
                                }
                                className="h-auto w-auto"
                              />
                            </div>
                            <div>
                              <P
                                fontSize="13px"
                                color={"#374072"}
                                fontWeight="500"
                              >
                                {activity?.ad?.action === "buy"
                                  ? "Buy"
                                  : "Sell"}
                              </P>
                              <P fontSize="10px" color={"#7A809B"}>
                                {
                                  new Date(activity.created_at)
                                    .toLocaleString()
                                    .split(",")[1]
                                }
                              </P>
                            </div>
                          </div>
                        </td>
                        <td className="col-start-2 col-end-4">
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {activity?.account?.email}
                            </P>
                          </div>
                        </td>
                        <td>
                          <div className="flex justify-center items-start">
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              NGN {activity?.price}/ USDT
                            </P>
                          </div>
                        </td>
                        <td>
                          <div className="flex justify-center">
                            <div className="">
                              <P
                                fontSize="13px"
                                color={"#0087B5"}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setTransaction(activity);
                                  setopenModal(true);
                                }}
                              >
                                View
                              </P>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <Badge
                              color={color(activity.status)}
                              bg={bgColor(activity.status)}
                            >
                              {activity.status}
                            </Badge>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </SendReceiveTableStyle>
          );
        })}
      <div>
        {openModal ? (
          <ActivityModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setopenModal(false);
            }}
            order={transaction}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ActivitiesTable;
